import { supabase } from "@/integrations/supabase/client";

/**
 * Auto-save a completed summary to the content_summaries table.
 * Returns true on success, false on failure. Silently skips if no userId.
 */
export async function autoSaveSummary({
  userId,
  videoUrl,
  videoId,
  summaryContent,
  author,
}: {
  userId?: string;
  videoUrl: string;
  videoId: string | null;
  summaryContent: string;
  author?: string | null;
}): Promise<boolean> {
  if (!userId) return false;
  try {
    const { error } = await supabase.from("content_summaries").insert({
      user_id: userId,
      video_url: videoUrl,
      video_id: videoId,
      summary_content: summaryContent,
      author: author || null,
    });
    if (error) {
      console.warn("[auto-save] Failed:", error.message);
      return false;
    }
    return true;
  } catch (e) {
    console.warn("[auto-save] Error:", e);
    return false;
  }
}
